import StreamSymbol from 'enums/StreamSymbol'
import { Metadata } from '../../adaptor/metadata'
import dataStreamResolver from '../document/dataStreamResolver'

export const isVoc = (metadata: Metadata) => {
  const { dataStream } = dataStreamResolver(metadata)

  return dataStream === StreamSymbol.VOC && metadata.isVocDisplay()
}

export default isVoc
